import React from "react";
import { Row, Col } from "react-bootstrap";
import "./NewProducts.css";

// Import hero images
import bellMathsHero from "../../images/Hero1/BellMaths-1.png";
import bellDiaryHero from "../../images/Hero1/BellDairy-1.png";
import encycGamesHero from "../../images/Hero1/Encycgames-1.png";

const NewProducts = () => {
  const products = [
    {
      id: "bellmaths",
      name: "BellMaths",
      category: "EdTech",
      aiLabel: "AI",
      description: "Advanced AI-powered mathematics learning platform for students and educators",
      fullDescription: "BellMaths is an innovative AI-powered mathematics learning platform designed to transform how students learn and practice mathematics. With intelligent problem generation and personalized learning paths, BellMaths makes math education engaging and effective.",
      image: bellMathsHero,
      logo: "/belldairy/BellDairyLogo.png",
      domain: "https://www.bellmaths.com",
      features: [
        "AI-powered problem generation",
        "Personalized learning paths",
        "Real-time feedback and assessment",
        "Interactive math practice",
        "Progress tracking and analytics"
      ]
    },
    {
      id: "encycgames",
      name: "EncycGames",
      category: "Sports Tech",
      aiLabel: "AI",
      description: "Revolutionary sports technology platform powered by AI for athletes and coaches",
      fullDescription: "EncycGames is a cutting-edge sports technology platform that leverages AI to help athletes and coaches analyze performance, optimize training, and achieve peak results. Transform your athletic journey with data-driven insights.",
      image: encycGamesHero,
      logo: "/belldairy/BellDairyLogo.png",
      domain: "https://www.encycgames.com",
      features: [
        "Performance analytics and insights",
        "AI-driven training recommendations",
        "Real-time performance tracking",
        "Comprehensive athlete profiles",
        "Coach collaboration tools"
      ]
    },
    {
      id: "belldiary",
      name: "BellDiary",
      category: "EdTech",
      aiLabel: "AI",
      description: "Transforming syllabi into textbooks, schedules, and labs through agentic AI. Collaborate in real-time from curriculum to mastery.",
      fullDescription: "Bell Diary is an AI-driven ecosystem that automates the heavy lifting of educational planning and content creation. By leveraging agentic AI, the platform deconstructs any syllabus into a structured digital book, complete with day-by-day teaching schedules, hands-on lab exercises, and automated assessments. It fosters a collaborative environment where teachers and students interact through NotebookLM-style insights and integrated chat, turning static curricula into dynamic, personalized learning paths.",
      image: bellDiaryHero,
      logo: "/belldairy/BellDairyLogo.png",
      domain: "https://www.belldiary.com",
      features: [
        "Agentic Content Synthesis: Automatically generates detailed textbooks, practical lab manuals, and assessments directly from your syllabus.",
        "Dynamic Scheduling: Crafts a granular daily teaching and practice calendar that adapts to the specific needs of your academic term.",
        "Collaborative AI Hub: Enables students and teachers to interact with course materials through shared notebooks and intelligent chat interfaces.",
        "Integrated Practical Labs: Delivers step-by-step lab instructions and experimental frameworks to bridge the gap between theory and practice.",
        "Holistic Assessment Engine: Simplifies evaluation with AI-generated quizzes and assignments designed to track progress in real-time."
      ]
    }
  ];

  return (
    <div className="new-products-container">
      <div className="products-content-wrapper">
        {products.map((product, index) => (
          <div key={product.id} className={`product-section ${index % 2 === 0 ? "even" : "odd"}`}>
            <Row className={`product-row ${index % 2 === 1 ? "reverse" : ""}`}>
              <Col md={6} className="product-image-col">
                <div className="product-image-wrapper">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="product-hero-image"
                  />
                </div>
              </Col>

              <Col md={6} className="product-content-col">
                <div className="product-content">
                  <div className="product-badges">
                    <span className="product-category-badge">{product.category}</span>
                    <span className="product-ai-badge">{product.aiLabel}</span>
                  </div>
                  <h2 className="product-name">{product.name}</h2>
                  <p className="product-short-description">{product.description}</p>
                  <p className="product-full-description">{product.fullDescription}</p>

                  <div className="product-features">
                    <h4 className="product-features-title">Key Features:</h4>
                    <ul className="product-features-list">
                      {product.features.map((feature, idx) => (
                        <li key={idx}>{feature}</li>
                      ))}
                    </ul>
                  </div>

                  <div className="product-launch-btn">
                    <a
                      href={product.domain}
                      target="_blank"
                      rel="noreferrer"
                      className="launch-link"
                    >
                      Explore {product.name} →
                    </a>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewProducts;
